import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      zIndex: 2,
      background: palette.background.default
    },
    default: {
      '@media (min-width: 1280px)': {
        left: '280px'
      }
    },
    imageChargement: {
      position: 'absolute',
      top: 'calc(50% - 50px)',
      left: 'calc(50% - 50px)',
      marginLeft: 'auto',
      marginRight: 'auto',
      animation: '1.4s ease-in-out infinite $imageChargementAnim'
    },
    '@keyframes imageChargementAnim': {
      '0%': {
        transform: 'rotateZ(0deg)'
      },
      '60%': {
        transform: 'rotateZ(190deg)'
      },
      '100%': {
        transform: 'rotateZ(360deg)'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
